import React from 'react';
import { Box } from '@mui/material';

import { hexToRgba } from '../Helpers/generalHelpers';

interface ColorLegendProps {
  legends?: {
    [key: string]: any;
  };
}

const ColorLegend: React.FC<ColorLegendProps> = ({ legends }) => (
  <Box className={'layer-color-legend-container'}>
    {Object.entries(legends ?? {}).map(([key, value]) => (
      <Box key={`${key}-${value}`} className={'legend-title'}>
        <Box
          className={`legend-color-circle`}
          sx={{
            backgroundColor: hexToRgba(value, 0.8),
            border: value ? `1px solid ${value}` : '',
          }}
        ></Box>
        {key}
      </Box>
    ))}
  </Box>
);

export default ColorLegend;
